import {Link} from 'react-router-dom'
import { formatDate } from '../../../../utils/date'
import { formatPrice } from '../../../../utils/common';

const CostAnalysisReportChildTableRow = ({row, minVariantCostPrice}: any) => {
  const hasAnyPo = [1, 2, 3].some((index) => row[`po_${index}`]);

  return (
    <>
      <tr>
        <td className='text-center'></td>
        <td>
          {row.parent_product_name} -<strong> {row?.variant_name}</strong>
        </td>
        <td>{row.variant_sku}</td>
        <td>{row.variant_cost != null ? `$${row.variant_cost.toFixed(2)}` : '-'}</td>
        <td></td>
        <td>
          {row.variant_latest_po_cost != null ? `$${row.variant_latest_po_cost.toFixed(2)}` : '-'}
        </td>
        <td>
          <div>
            {row.variant_po_average_cost != null
              ? `$${row.variant_po_average_cost.toFixed(2)}`
              : '-'}
          </div>
        </td>
        <td>
          <div className='d-flex flex-column gap-1'>
            {hasAnyPo ? (
              [1, 2, 3].map((index) => {
                const poField = row[`po_${index}`]
                const poDate = row[`po_${index}_date`]

                if (!poField) return null // Don't render anything for missing ones

                const [poId, poCost] = poField.split('/')
                const poLink = `https://v2.skuvault.com/purchaseorders/edit/${poId}`

                return (
                  <div key={index} className='app-default-date-cell position-relative py-1'>
                    <span className='app-default-date-area position-relative'>
                      <Link to={poLink} target='_blank' className='text-dark text-hover-primary'>
                        {poId}
                      </Link>
                      <span className={`fw-bold ${Number(poCost) !== minVariantCostPrice ? 'text-primary' : ''}`} > / {formatPrice(poCost,false)}</span>
                      <span className='popover app-default-date-tooltip fw-semibold lh-1 fs-8'>
                        {formatDate(poDate, false)}
                      </span>
                    </span>
                  </div>
                )
              })
            ) : (
              <div>-</div> // If no PO at all, show a single dash
            )}
          </div>
        </td>
      </tr>
    </>
  )
}

export default CostAnalysisReportChildTableRow
